import { Box, Flex } from '@chakra-ui/react';
import { themeVariables } from '@meteraprotocol/sdk/ui/theme.js';
import React from 'react';

interface StatusDotprops {
  status: string;
  showStatus: boolean;
}

const StatusDot: React.FC<StatusDotprops> = ({ status, showStatus }) => {
  const colors: { [key: string]: string } = {
    Confirmed: '#22C55E',
    Failed: '#EF4444',
    Invalid: '#EF4444',
    Cancelled: '#EF4444',
    Pending: '#FCD34D',
    Confirming: '#FCD34D',
    Processing: '#FCD34D',
    Cancelling: '#EF4444',
    Insufficient: '#FBBF24',
  };

  const isAnimating =
    status === 'Pending' || status === 'Cancelling' || status === 'Processing';

  return (
    <Flex align="center" gap={2}>
      <Box
        style={
          isAnimating
            ? { animation: `${themeVariables.blinkAnimation} 1s infinite` }
            : {}
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
        >
          <circle cx="3" cy="3" r="3" fill={colors[status]} />
        </svg>
      </Box>
      {showStatus && (
        <Box
          style={
            isAnimating
              ? { animation: `${themeVariables.opacityAnimation} 1s infinite` }
              : {}
          }
        >
          {status}
        </Box>
      )}
    </Flex>
  );
};

export default StatusDot;
